export default "__VITE_ASSET__b3572862__"